export default __webpack_public_path__ + "static/media/1.94de8911.webp";